import PropTypes from 'prop-types'
import { DateTime } from 'luxon'

function DateRange({ startDate, endDate }) {
  // Parse dates using their embedded timezone offset to avoid hydration mismatches
  // This ensures server and client render the same result regardless of system timezone
  const start = DateTime.fromISO(startDate, { setZone: true })
  const end = DateTime.fromISO(endDate, { setZone: true })

  const startMonth = start.toFormat('LLL')
  const startDay = start.day
  const startYear = start.year
  const endMonth = end.toFormat('LLL')
  const endDay = end.day
  const endYear = end.year

  const sameDay = startDay === endDay && startMonth === endMonth && startYear === endYear
  const sameMonth = startMonth === endMonth
  const sameYear = startYear === endYear

  // Jul 2 – 15, 2022
  // Jul 31 – Aug 5, 2022
  // Jul 31, 2022 – Aug 5, 2023

  if (sameDay) {
    return (
      <span>
        {startMonth} {startDay}, {startYear}
      </span>
    )
  }
  return (
    <span>
      {startMonth} {startDay}{!sameYear && `, ${startYear}`} - {!sameMonth && endMonth} {endDay}, {endYear}
    </span>
  )
}

DateRange.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default DateRange
